module.exports = __webpack_public_path__ + "img/santander.7de072f.svg";